import Vue from 'vue'
export default Vue.extend({
  name: 'PlanList',
  props: {
    plans: {
      type: Array
    },
    mandatory: {
      type: Boolean
    },
    selected: Boolean
  },
  computed: {
    orderByPrice() {
      return this.plans.sort((a: any, b: any) => (a.price > b.price) ? 1 : -1)
    }
  },
  methods: {
    choose(plan: any) {
      this.$emit('choose', plan)
    }
  }
})
